export const reactNativeQuestions = [
  {
    id: 1,
    question: "What are the main differences between React and React Native?",
    parts: [
      {
        type: "text",
        content: `**React vs React Native**

**React (Web)**
- 🖥️ Renders to the DOM (HTML tags)
- 🎨 CSS for styling
- 🌐 Browser environment

**React Native (Mobile)**
- 📱 Renders to native components (\`View\`, \`Text\`, \`TextInput\`)
- 🎨 \`StyleSheet\` API for styles
- 🧩 Accesses native APIs; iOS/Android
- 🧭 Mobile navigation/performance patterns`
      }
    ]
  },
  {
    id: 2,
    question: "Explain FlatList and when to use it over ScrollView",
    parts: [
      {
        type: "text",
        content: `**FlatList vs ScrollView**

**FlatList**
- 🧮 Virtualized list for long datasets
- 🎯 Renders only visible items
- 🔁 Supports pull-to-refresh, pagination

**ScrollView**
- 🧾 Renders all children at once
- ✅ Use for short lists (< ~100 items)

Guidance: prefer FlatList for large/dynamic/performance-critical lists.`
      },
      {
        type: "code",
        language: "jsx",
        content: "<FlatList\n  data={items}\n  renderItem={({ item }) => <Item item={item} />}\n  keyExtractor={item => item.id}\n/>"
      }
    ]
  },
  {
    id: 3,
    question: "How do you handle different screen sizes in React Native?",
    parts: [
      {
        type: "text",
        content: `**Responsive RN Layouts**

- 📐 \`Dimensions\` / \`useWindowDimensions\`
- 📏 Percentage-based layouts, Flexbox
- 🧭 Platform-specific branches
- 📦 Libraries: \`react-native-responsive-screen\`, \`react-native-size-matters\`
- 🧪 Test across multiple device sizes`
      },
      {
        type: "code",
        language: "javascript",
        content: "import { Dimensions, useWindowDimensions, Platform } from 'react-native';\nconst { width, height } = Dimensions.get('window');\nconst size = useWindowDimensions();\nconst toolbarHeight = Platform.OS === 'ios' ? 44 : 56;"
      }
    ]
  },
  {
    id: 4,
    question: "What is the bridge in React Native and what are its limitations?",
    parts: [
      {
        type: "text",
        content: `**React Native Bridge**

Legacy Bridge:
- 🔌 Serializes messages JS ↔ native asynchronously
- ⚠️ Overhead for chatty operations and animations

New Architecture:
- 🧠 JSI, TurboModules, Fabric
- 🔗 Direct bindings and improved performance`
      }
    ]
  },
  {
    id: 5,
    question: "In React Native, how do we handle long scrolls with hundreds of tiles?",
    parts: [
      {
        type: "text",
        content: `**Performance for Long Lists**

- 🔑 Stable keys
- 🧠 Memoized \`renderItem\` and item components
- ⚙️ Tune \`initialNumToRender\`, \`maxToRenderPerBatch\`, \`windowSize\`
- ✂️ \`removeClippedSubviews\`
- 📏 \`getItemLayout\` for fixed heights
- ⚡ Consider FlashList for better defaults`
      },
      {
        type: "code",
        language: "jsx",
        content: "<FlatList\n  data={items}\n  renderItem={({ item }) => <TileComponent item={item} />}\n  keyExtractor={item => item.id.toString()}\n  initialNumToRender={10}\n  maxToRenderPerBatch={5}\n  windowSize={5}\n  removeClippedSubviews\n  onEndReached={loadMore}\n  onEndReachedThreshold={0.5}\n/>"
      }
    ]
  }
];

